import * as React from 'react';
import { styled, css } from '../theme-provider';
import { useTableContext } from './table';
export const StyledTableHead = styled.thead.withConfig({ displayName: "StyledTableHead", componentId: "sc-o10x5u" }) `${({ isFixedHeaderRowActive, tableWidth = 0, stickyHeaderOffset = 0, headerHeight = 0, }) => isFixedHeaderRowActive &&
    css `
			height: ${headerHeight}px;
			tr {
				top: ${stickyHeaderOffset}px;
				position: fixed;
				width: ${tableWidth}px;
			}
		`}`;
export const TableHead = ({ children }) => {
    const { isFixedHeaderRowActive, tableWidth, stickyHeaderOffset, headerHeight } = useTableContext();
    return (React.createElement(StyledTableHead, { isFixedHeaderRowActive: isFixedHeaderRowActive, tableWidth: tableWidth, stickyHeaderOffset: stickyHeaderOffset, headerHeight: headerHeight }, children));
};
